import React from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';

interface Tab {
  id: string;
  label: string;
  count?: number;
}

interface TabBarProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  brand?: BrandConfig;
}

const TabBar: React.FC<TabBarProps> = ({ tabs, activeTab, onTabChange, brand }) => {
  return (
    <div
      className="px-6 py-2 border-b flex gap-1 overflow-x-auto"
      style={{ backgroundColor: 'white', borderColor: brand?.colors?.border || '#E5E7EB' }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-2 ${
            activeTab === tab.id ? '' : 'hover:bg-gray-100'
          }`}
          style={{
            backgroundColor: activeTab === tab.id ? (brand?.colors?.primary || '#2563EB') : 'transparent',
            color: activeTab === tab.id ? (brand?.colors?.onPrimary || 'white') : (brand?.colors?.text || '#374151'),
          }}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span
              className="px-1.5 py-0.5 rounded-sm text-xs font-medium"
              style={{
                backgroundColor: activeTab === tab.id ? 'rgba(255,255,255,0.2)' : (brand?.colors?.bgLight || '#F3F4F6'),
                color: activeTab === tab.id ? (brand?.colors?.onPrimary || 'white') : (brand?.colors?.textLight || '#6B7280'),
              }}
            >
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TabBar;
